// Alias de las soluciones y sus respectivas urls
export const paramsSoluciones = {
  ciberseguridad: 'ciberseguridad',
  'conectividad-wifi': 'conectividad-wifi',
  'experiencia-cliente': 'experiencia-cliente',
  'soluciones-digitales': 'soluciones-digitales',
  cloud: 'cloud',
  'gestion-negocio': 'gestion-negocio',
  teletrabajo: 'teletrabajo',
  'comercio-electronico': 'comercio-electronico',
  'big-data-iot': 'big-data-iot',
};


export const environmentsUrls = {
  dev: ['127.0.0.1'],
  qa: ['col10mgmt.tsm.inet', 'qa.cms.col', 'prod.cms.col'],
  production: ['movistar.es'],
};
